import React from "react";

const About = () => {
  return (
    <div style={{ 
      minHeight: "100vh", 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center",
      background: "#111",
      color: "#fff",
      flexDirection: "column",
      textAlign: "center",
      padding: "40px"
    }}>
      <h1 style={{ fontSize: "2.5rem", color: "#f5d778", marginBottom: "20px" }}>
        About Almond Software
      </h1>

      <p style={{ fontSize: "1.2rem", maxWidth: "700px", lineHeight: "1.8", marginBottom: "20px" }}>
        <strong>ACLIP</strong> is a sophisticated short-video platform meticulously designed with an 
        <em> auto-scroll feature </em> and intelligently <em>filtered content</em>, providing users with 
        a seamless and engaging viewing experience. Integrated with a timer, ACLIP allows viewers to monitor 
        the duration of time spent consuming short-form videos, promoting mindful usage.
      </p>

      <p style={{ fontSize: "1.2rem", maxWidth: "700px", lineHeight: "1.8", marginBottom: "20px" }}>
        Developed and crafted with excellence by <strong>Almond Software</strong>, ACLIP exemplifies our 
        commitment to creating premium digital solutions that combine innovation, usability, and aesthetic 
        finesse.
      </p>

      <p style={{ fontSize: "1.2rem", marginTop: "30px" }}>
        Discover more about our projects at{" "}
        <a 
          href="https://almondsoftwares.in" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: "#f5d778", textDecoration: "underline" }}
        >
          almondsoftwares.in
        </a>
      </p>
    </div>
  );
};

export default About;
